import { Pipe, PipeTransform } from '@angular/core';

declare var window:any;

@Pipe({
  name: 'filter',
  pure: false // changes are shown immediately
})
export class FilterPipe implements PipeTransform {
  filterTimeout = null;
  cache:any = {};
  cacheTime = 1500; // 1.5 seconds
  transform(items: any[], searchText: string, showChecked:string): any[] {
    // console.log("start")
    if (typeof window.cached == 'undefined') {
      window.cached = {};
      window.itemsString = "";
    }
    this.cache = window.cached;
    if(!items) {
       return [];
    }

    let key = showChecked+"+"+searchText;
    if (typeof this.cache[key] != "undefined") {
      let cache = this.cache[key];
      if (cache.expire < new Date().valueOf()) {
        // console.log("used cache", this.cache[key]);
        return this.cache[key].items;
      }
      // console.log("re-built")
      // console.log("filter:", key);
      try {
        delete this.cache[key];
      } catch(e) {

      }
    }

    if (searchText) {
      if (searchText.length >= 2) {
        // console.log("FILTERING")
        searchText = searchText.toLowerCase().replace(/ \- /g," ");
        // console.log("searchText1:",searchText)
        searchText = searchText.replace("  ", " ");
        // console.log("searchText2:",searchText)
        let words = searchText.split(' ');
        let _items = items.filter( it => {
          let found = false,
              name = it.name.toLowerCase(),
              score = 0;
          for (let i=0;i<words.length;i++) {
            let word = words[i].trim();
            if (!word) {
              continue;
            }
            if (words[i] && name.includes(words[i])) {
              found = true;
              // break
              score += 1;
            }
          }
          it.score = score;
          // Ignore the checked state if there's search text.
          return found;
        });
        if (_items) {
          _items.sort((a, b) => {
            if (a.score > b.score) {
              return -1;
            }
            if (a.score < b.score) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.setCache(key, _items);
          // console.log("filtered:",searchText, showChecked)
          return _items;
        }
        return [];
      }
    }
    if(showChecked == "all") {
      this.setCache(key, items);
      // console.log("done")
      return items;
    }

    if (showChecked == "checked") {
      let _items = items.filter( it => {
        return it.checked;
      });
      this.setCache(key, _items);
      return _items;
    }
    if (showChecked == "unchecked") {
      let recent = (new Date().valueOf()) - (10 * 60 * 1000),
          _items = items.filter( it => {
            return !it.checked || new Date(it.last_time_checked).valueOf() >= recent;
          });
      this.setCache(key, _items);
      return _items;
    }

    if (showChecked == "recent") {
      // A day ago.
      let yesterday = (new Date().valueOf()) - (24 * 60 * 60 * 1000);
      let _items = items.filter( it => {

        // return !it.checked && !it.removing;
        return new Date(it.last_time_checked).valueOf() >= yesterday;

      });
      // this.setCache(key, _items);

      _items.sort((a, b) => {
        if (a.last_time_checked > b.last_time_checked) {
          return -1;
        }
        if (a.last_time_checked < b.last_time_checked) {
          return 1;
        }
        return 0;
      });
      this.setCache(key, _items);
      return _items;
    }

    if (showChecked == "order") {
      let _items = items.filter( it => {
        return 1;
      });
      _items.sort((a, b) => {
        return new Date(b.last_time_checked).valueOf() - new Date(a.last_time_checked).valueOf();
      });
      this.setCache(key, _items);
      return _items;
    }

    if (showChecked == "order-old") {
      let _items = items.filter( it => {
        return 1;
      });
      _items.sort((a, b) => {
        return new Date(a.last_time_checked).valueOf() - new Date(b.last_time_checked).valueOf();
      });
      this.setCache(key, _items);
      return _items;
    }

    /*
    return items.filter( it => {
      return (
        (showChecked == "unchecked" && (!it.checked || [0,"0"].indexOf(it.checked) != -1)) ||
        (showChecked == "checked" && it.checked)
      );
    });
    */
    return [];
  }

  setCache(key, items) {
    this.cache[key] = {
      "items": items,
      "expire": new Date().valueOf() + this.cacheTime,
    };
  }
}